import { resolveEndpoints, type Endpoints } from '@trading/infrastructure/src/config/endpoints'

/**
 * Адреса бэкенда для текущего окружения.
 *
 * Настраивается только двумя переменными:
 *   NUXT_PUBLIC_API_HOST    — хост API (пусто = текущий хост страницы)
 *   NUXT_PUBLIC_API_VERSION — версия REST API (по умолчанию v1)
 *
 * Отдельно, только для SSR-запросов изнутри кластера:
 *   NUXT_API_HOST_INTERNAL  — внутренний адрес API (например http://backend-api.platform)
 */
export function useEndpoints(): Endpoints {
  const config = useRuntimeConfig()
  const requestUrl = useRequestURL({ xForwardedHost: true, xForwardedProto: true })

  const internalHost = import.meta.server ? (config.apiHostInternal as string) : ''
  const host = internalHost || (config.public.apiHost as string)

  return resolveEndpoints({
    host,
    apiVersion: config.public.apiVersion as string,
    origin: requestUrl.origin
  })
}
